export default {
      id: "logo-small-usage",
      viewBox: "0 0 61 60",
      url: "/" + "sprite.svg#logo-small",
      toString: function () {
        return this.url;
      }
    }